import { render, staticRenderFns } from "./default.vue?vue&type=template&id=6815fbb4&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=6815fbb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Sidebar: require('/home/travis/build/Polumathes/LTNG-Transact-Frontend/components/SidebarElements/Sidebar.vue').default,BasePlatform: require('/home/travis/build/Polumathes/LTNG-Transact-Frontend/components/Base/Platform.vue').default})
